<template>
  <el-dialog v-model="visible" title="선적 상세" width="700px">
    <template v-if="shipment">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="선적번호">{{ shipment.shipment_number }}</el-descriptions-item>
        <el-descriptions-item label="유형">{{ shipment.shipment_type_display }}</el-descriptions-item>
        <el-descriptions-item label="상태">
          <el-tag :type="getStatusType(shipment.status)">{{ shipment.status_display }}</el-tag>
          <el-tag v-if="shipment.is_delayed" type="danger" style="margin-left: 5px">지연</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="메인오더">{{ shipment.main_request_number }}</el-descriptions-item>
        <el-descriptions-item label="LC번호">{{ shipment.lc_number || '-' }}</el-descriptions-item>
        <el-descriptions-item label="수량">{{ shipment.quantity?.toLocaleString() }}</el-descriptions-item>
        <el-descriptions-item label="카톤수">{{ shipment.carton_count || '-' }}</el-descriptions-item>
        <el-descriptions-item label="총중량">{{ shipment.gross_weight || '-' }} kg</el-descriptions-item>
      </el-descriptions>

      <el-divider />

      <el-descriptions title="운송 정보" :column="2" border>
        <el-descriptions-item label="선사">{{ shipment.carrier || '-' }}</el-descriptions-item>
        <el-descriptions-item label="선박명">{{ shipment.vessel_name || '-' }}</el-descriptions-item>
        <el-descriptions-item label="B/L번호">{{ shipment.bl_number || '-' }}</el-descriptions-item>
        <el-descriptions-item label="컨테이너번호">{{ shipment.container_number || '-' }}</el-descriptions-item>
        <el-descriptions-item label="선적항">{{ shipment.port_of_loading }}</el-descriptions-item>
        <el-descriptions-item label="양륙항">{{ shipment.port_of_discharge }}</el-descriptions-item>
      </el-descriptions>

      <el-divider />

      <el-descriptions title="일정 정보" :column="2" border>
        <el-descriptions-item label="ETD">{{ shipment.etd }}</el-descriptions-item>
        <el-descriptions-item label="ATD">{{ shipment.atd || '-' }}</el-descriptions-item>
        <el-descriptions-item label="ETA">{{ shipment.eta }}</el-descriptions-item>
        <el-descriptions-item label="ATA">{{ shipment.ata || '-' }}</el-descriptions-item>
        <el-descriptions-item label="운송일수">{{ shipment.transit_days || '-' }}일</el-descriptions-item>
        <el-descriptions-item label="도착까지">
          <el-tag
            v-if="shipment.days_until_eta !== null && shipment.days_until_eta !== undefined"
            :type="shipment.days_until_eta < 0 ? 'danger' : 'info'"
            size="small"
          >
            {{ shipment.days_until_eta < 0 ? `D+${Math.abs(shipment.days_until_eta)}` : `D-${shipment.days_until_eta}` }}
          </el-tag>
        </el-descriptions-item>
      </el-descriptions>

      <el-divider v-if="shipment.remarks" />

      <el-descriptions v-if="shipment.remarks" title="비고" :column="1">
        <el-descriptions-item>{{ shipment.remarks }}</el-descriptions-item>
      </el-descriptions>
    </template>

    <template #footer>
      <el-button @click="visible = false">닫기</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  shipment: {
    type: Object,
    default: null
  }
})

const emit = defineEmits(['update:modelValue'])

const visible = ref(props.modelValue)

const getStatusType = (status) => {
  const types = {
    'PLANNED': 'info',
    'BOOKED': 'warning',
    'LOADED': '',
    'IN_TRANSIT': '',
    'ARRIVED': 'success',
    'DELIVERED': 'success',
    'CANCELLED': 'danger'
  }
  return types[status] || 'info'
}

watch(() => props.modelValue, (val) => {
  visible.value = val
})

watch(visible, (val) => {
  emit('update:modelValue', val)
})
</script>
